/**
 * Dòng đơn mua hiển thị / in (05/11/2026): đơn lập từ nhiều LSX lưu 1 dòng / kế hoạch — gộp lại 1 dòng / vật tư
 * (cùng vật tư + đơn giá + ĐVT nhập): cộng SL đặt, SL nhận, SL theo ĐVT nhập; giữ danh sách LSX và ghi chú.
 */
export function groupPurchaseOrderLines(items: any[]): any[] {
  const groups = new Map<string, any>();
  for (const it of items || []) {
    const k = [it.materialId, Number(it.unitPrice || 0), it.entryUnit || ""].join("|");
    const po = it.productionOrder || it.materialPlan?.productionOrder;
    const g = groups.get(k);
    if (!g) {
      groups.set(k, { ...it, __orders: po ? [po] : [], __notes: it.notes ? [it.notes] : [] });
      continue;
    }
    g.quantity = Number(g.quantity || 0) + Number(it.quantity || 0);
    g.receivedQty = Number(g.receivedQty || 0) + Number(it.receivedQty || 0);
    if (g.entryQty != null && it.entryQty != null) g.entryQty = Math.round((Number(g.entryQty) + Number(it.entryQty)) * 1000) / 1000;
    if (g.amount != null && it.amount != null) g.amount = Number(g.amount) + Number(it.amount);
    if (po && !g.__orders.some((o: any) => o.id === po.id)) g.__orders.push(po);
    if (it.notes && !g.__notes.includes(it.notes)) g.__notes.push(it.notes);
  }
  return [...groups.values()].map((g) => ({ ...g, notes: g.__notes.join(" · ") || null }));
}
